import { ClickMenuAction, ActionTypes } from './types';

export type ClickMenu = (isOpened: boolean) => ClickMenuAction;

export const clickMenu: ClickMenu = (isOpened) => ({
  type: ActionTypes.MENU_CLICK,
  isOpened,
});
